<template>
  <ul class="popup-body">
    <li class="item" v-for="(item, $index) in options" @click="itemSelect(item, $index)">
      <div class="row fl">
        <span class="radio-core" :class="{'act': item.flag}"></span>
        <span class="item-name elli" :class="{'show-menu': (editSwitch || delSwitch) && item.flag}" v-text="item[valKey]"></span>
      </div>
      <div class="row fr edit-menu" v-if="item.flag">
        <a v-if="editSwitch" href="javascript:;" class="menu-item edit" @click.stop="edit($index, item.index)"></a>
        <a v-if="delSwitch" href="javascript:;" class="menu-item remove" @click.stop="remove(item.index)"></a>
      </div>
    </li>
    <li v-if="addItemSwitch" class="item add-item" :class="{'item-empty': isItemEmpty()}" @click="addItemCallBack()">
      <span>添加一项</span>
    </li>
  </ul>
</template>

<script>
  import Vue from 'vue';

  export default {
    name: "radio_item",
    props: {
      valKey: null,
      options: [Array, Object],
      editSwitch: Boolean,
      delSwitch: Boolean,
      addItemSwitch: Boolean,
      edit: Function,
      remove: Function,
      radioSelect: Function,
      // selectCallBack: Function,
      addItemCallBack: Function
    },
    methods: {
      isItemEmpty() {
        let res = false;

        if (this.options.length <= 0 && Object.keys(this.options).length <= 0) {
          res = true;
        }

        return res;
      },
      itemSelect(item, index) {
        this.options.forEach(function (item) {
          Vue.set(item, 'flag', false);
        });
        Vue.set(item, 'flag', true);
        this.radioSelect(item, index);
      }
    }
  }
</script>

<style scoped>
  @import "../style/css/radio_item.css";
</style>



// WEBPACK FOOTER //
// src/components/radio_item.vue